import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";

const FormSelect = ({
  label,
  name,
  control,
  options,
  validationError,
  placeholder = "Izberi...",
}) => {
  return (
    <Form.Group controlId={label} className="mb-2">
      <Form.Label>{label}</Form.Label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <Select
              options={options}
              value={
                options.find((option) => option.value === field.value) || null
              }
              onChange={(selectedOption) =>
                field.onChange(selectedOption.value)
              }
              placeholder={placeholder}
            />
          );
        }}
      />
      {validationError && <p className="text-danger">{validationError}</p>}
    </Form.Group>
  );
};

export default FormSelect;
